var button = document.querySelector('.ar .ar-button');
var buttonMobile = document.querySelector('.header-top .ar-button');
var popup = document.querySelector('.ar__popup');
var close = document.querySelector('.ar__close');
var items = document.querySelectorAll('.ar-item');

// Open pop-up on click
if (window.innerWidth > 960) {
    button.addEventListener('click', function () {
        popup.classList.add('ar__popup--open');
        button.classList.add('ar-button--active');
    })
}

else {
    buttonMobile.addEventListener('click', function () {
        popup.classList.add('ar__popup--open');
    })
}


// Close pop-up on click
close.addEventListener('click', function () {
    popup.classList.remove('ar__popup--open');
    button.classList.remove('ar-button--active');
})


// Open pop-up when focus is on an list item
items.forEach(function(item) {
    item.addEventListener('focus', function () {
        popup.classList.add('ar__popup--open');
    })
});

// Close pop-up when focus is out of an list item
items.forEach(function(item) {
    item.addEventListener('focusout', function () {
        popup.classList.remove('ar__popup--open');
    })
});